<template>
	<label class="upload">
		<svg-sprite icon-id="icon_download" width="80" height="80"></svg-sprite>
		<span>Upload file</span>
		<input style="display: none;" accept=".xlsx" type="file" @change="onFile">
	</label>
</template>

<script>
import { mapActions } from "vuex";

export default {
	name: "UploadFile",
	data: () => ({
		isFileValid: false
	}),
	methods: {
		...mapActions([ 'setAlert' ]),
		onFile(evt) {
			const { files } = evt?.target || evt?.dataTransfer;
			if (files.length) {
				const { name } = files[0];
				const format = name.split('.').pop();
				const isFormat = [ 'xlsx' ].includes(format);

				if (isFormat) {
					const reader = new FileReader();
					reader.readAsDataURL(files[0]);

					reader.onload = () => {
						const file = {
							name,
							value: reader.result,
							url: reader.result
						};

						this.$emit('updateFile', file);
					};
				} else {
					this.setAlert({ type: "error", message: "Only .xlsx format allowed" });
					this.$emit('updateFile', null);
				}
			}
		},
	}
};
</script>

<style scoped lang="scss">
.upload {
	cursor: pointer;
	display: flex;
	align-items: center;
	justify-content: center;
	flex-direction: column;
	padding: 40px;
	height: 200px;
	width: 200px;
	border: 4px solid #19bc38;
	color: #19bc38;
}
</style>
